import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Grid, Button, TextField, CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const CDRHistory = () => {
  const [pin, setPin] = useState<string>("");
  const [data, setData] = useState<any>(null);
  const agGridRef = useRef<AgGridReact | null>(null);
  const [action, setAction] = useState<Boolean>(false);
  const [cardNumber, setCardNumber] = useState<string>("");

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const columnDefs: ColDef[] = [
    {
      field: "Date",
      headerName: "Date",
      filter: true,
      resizable: true,
      sortable: true,
      valueFormatter: ({ value }) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format("DD-MM-YYYY")
          : "-",
    },
    {
      field: "PIN",
      headerName: "Pin",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Card Number",
      headerName: "Card Number",
      filter: true,
      resizable: true,
      sortable: true,
    },

    {
      field: "Access Number",
      headerName: "Access Number",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Start Balance",
      headerName: "Start Balance",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Ending Balance",
      headerName: "End Balance",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Duration",
      headerName: "Duration",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "FROM MSSIDN",
      headerName: "From Msisdn",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "TO MSISDN",
      headerName: "To Msisdn",
      filter: true,
      resizable: true,
      sortable: true,
    },
  ];

  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };

  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (pin.trim().length > 9 || cardNumber.trim() !== "") {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please enter valid input.");
    }
  };

  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(
        `/product/CallingCardsHistory?Pin=${pin.trim()}&CardNumber=${cardNumber.trim()}`,
      )
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (apiresponse.Data?.length == 0 || apiresponse?.Data == null) {
          toast.error("Record not found.");
        } else {
          setData(apiresponse?.Data);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Calling Cards History</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <TextField
                className="formControl"
                label="Pin"
                variant="outlined"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                inputProps={{ maxLength: 10 }}
              />
            </Grid>

            <Grid item xs={5}>
              <TextField
                className="formControl"
                label="CardNumber"
                variant="outlined"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value)}
                inputProps={{ maxLength: 35 }}
              />
            </Grid>

            <Grid item xs={2}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <button
          className="small-btn"
          style={{ visibility: data ? "visible" : "hidden" }}
          onClick={() => {
            if (data) {
              exportGridDataAsCSV();
            }
          }}
        >
          Export as CSV
        </button>
      </div>
      {data && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={data}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default CDRHistory;
